const config = {
    baseFontSize: "18px",
    baseFontColour: "rgba(69, 69, 83, 0.95)",
    baseSerifFontFamily: `"Spectral", serif`,
    baseSansSerifFontFamily: `"Inter", sans-serif`,
    baseMonoFontFamily: `"Source Code Pro", monospace`,
};

export default config;
